import { memo } from 'react'

import type { TFilterComponents, TFilterConfig, TFilterOption } from '../../model/filterTypes'

import { ClientActions } from './ClientActions'
import { FilterOption } from './FilterOption'
import { FilterExtra } from './FilterExtra'

interface IFilterProps {
    catalogParams: string[] | null
    filterData: TFilterOption[] | undefined
    filterConfig: (id: string) => { type: string }
    components: TFilterComponents
}

export const Filter = memo(function Filter({
    catalogParams,
    filterData,
    filterConfig,
    components: { FilterWrapper, FilterApply, FilterReset, ...components }
}: IFilterProps) {
    return (
        <>
            <ClientActions
                filterData={filterData}
                catalogParams={catalogParams}
            />
            <FilterWrapper>
                {!!filterData?.length &&
                    filterData.map(option => {
                        return (
                            <FilterOption
                                {...option}
                                paramsData={
                                    !!catalogParams?.find(str => option.items.find(({ value }) => str === value))
                                }
                                components={components}
                                config={filterConfig(option.title) as ReturnType<TFilterConfig>}
                                key={option.title}
                            />
                        )
                    })}

                {FilterApply && <FilterExtra Component={FilterApply} />}

                {FilterReset && <FilterExtra Component={FilterReset} />}
            </FilterWrapper>
        </>
    )
})
